
import React from 'react'
import classNames from 'classnames'

const FormElementGroup = ({ title, cssClass, children, style }) => {
    if (!title) {
        return (
            <div
                className={classNames(
                    'form-element-group',
                    { [cssClass]: cssClass }
                )}
                style={style}
            >
                {children}
            </div>
        )
    }

    return (
        <div className="form-element-group" style={style}>
            {title ? <h5 className="form-element-group__title">{title}</h5> : null}
            <div
                className={classNames(
                    'form-element-group__children',
                    { [cssClass]: cssClass }
                )}
            >
                {children}
            </div>
        </div>
    )
}

export default FormElementGroup
